import {
  IGroupedMention,
  IGroupedMentionWithMentioner,
  IGroupedMentionsResponse
} from '../types/dashboard.types';
import { ORDER_COMMENT_TYPES_ENUM } from '../types/orders';

export const isCustomerChatMention = (mention: IGroupedMentionWithMentioner): boolean =>
  mention.commentTypeName === ORDER_COMMENT_TYPES_ENUM.CUSTOMER_CHAT;

export const filterGroupedMentionsByChannel = (
  response: IGroupedMentionsResponse | null | undefined,
  options: { isCustomerChat: boolean }
): IGroupedMentionsResponse => {
  const matchesChannel = (mention: IGroupedMentionWithMentioner) =>
    options.isCustomerChat
      ? isCustomerChatMention(mention)
      : !isCustomerChatMention(mention);

  const filterGroups = (groups: IGroupedMention[]): IGroupedMention[] =>
    groups.flatMap(group => {
      const mentions = group.mentions.filter(matchesChannel);
      return mentions.length ? [{ ...group, mentions }] : [];
    });

  return {
    pendingViewingMentions: filterGroups(response?.pendingViewingMentions ?? []),
    pendingResolutionMentions: filterGroups(response?.pendingResolutionMentions ?? []),
    resolvedMentions: filterGroups(response?.resolvedMentions ?? [])
  };
};
